// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubmenuItem_wrapper__xw8nk","listNavigation":"SubmenuItem_listNavigation__9lY5A","tiles":"SubmenuItem_tiles__5NFED"};